<script>
/*

"param_data_type：[0-boolean，1-Int,2-Float,3-String，4-Int Array，5-Float Array，6-String Array,7-Int 2维数组，8-Float 2维数组，9-String 2维数组,10-复合结构] \n" +
"param_show:[是否可视]\n" +
"param_show_type:[1-开关，2-双滑条，3-单选项，4-数字选择器（整数），5-下拉列表，6-多选框， 7-自定义（日历+时间组合）, 8-自定义(抽帧频率)，9-输入框，10-数字选择器（step 0.1小数）， 11-数字选择器（step 0.01小数）]\n" +
"param_name：[on:开关，type：[1-抽帧，2-云存，3-通用AI技能]]\n",
*/

/*
ai_data: 
    0: {id: 3, name: "人脸带口罩检测",…}
    id: 3
    name: "人脸带口罩检测"
    param_data: [{param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.5",…},…]
    0: {param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.5",…}
    param_default_val: "0.5"
    param_desc: ["默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时，才会被识别为违规佩戴，进行分析告警；", "开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；",…]
    0: "默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时，才会被识别为违规佩戴，进行分析告警；"
    1: "开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；"
    2: "推荐阈值范围：0.5~1，阈值越高，识别越精准，但漏识别概率增大。"
    param_name: "confidence"
    param_title: "置信度"
    param_type: 1
    param_val: "0-1.0"
    show_type: 1
    
    1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.4",…}
    param_default_val: "0.4"
    param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
    0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
    param_name: "suspect_confidence"
    param_title: "疑似值"
    param_type: 1
    param_val: "0-1.0"
    show_type: 1




id: 1
name: "未佩戴口罩"
result_desc: "未佩戴人员"
skill_desc: ["基于人体识别技术，判断是否佩戴口罩，未佩戴告警"]
0: "基于人体识别技术，判断是否佩戴口罩，未佩戴告警"
skill_title: "人脸AI视觉"
skill_type: 1
type: 2
use_suspect: 0


*/
var skill_mask = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 0,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 0,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "未佩戴口罩",
    param_desc: "基于人体识别技术，判断是否佩戴口罩，未佩戴告警",
    param_set_desc: "基于人体识别技术，判断是否佩戴口罩，未佩戴告警",
    param_default_val: "未佩戴口罩",
    param_val: "未佩戴口罩",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_default_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 1,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "未佩戴人员",
    param_desc: "",
    param_default_val: "未佩戴人员",
    param_val: "未佩戴人员",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_default_val: 3,
          param_min_val: 1,
          param_max_val: 32768,
          param_val: 3,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "人脸戴口罩检测",
          param_desc: "",
          param_default_val: "人脸戴口罩检测",
          param_val: "人脸戴口罩检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "人脸置信度",
          param_desc:
            "默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时，才会被识别为违规佩戴，进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；<br>推荐阈值范围：0.5~1，阈值越高，识别越精准，但漏识别概率增大。",
          param_default_val: 0.5,
          param_val: 0.5,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时，才会被识别为违规佩戴，进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；<br>推荐阈值范围：0.5~1，阈值越高，识别越精准，但漏识别概率增大。",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.4,
          param_val: 0.4,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "NoMask",
          param_val: "NoMask",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98996",
          param_val: "601d24e22f94e4b548d98996",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];

/*
ai_data: [{id: 15, name: "戴帽子检测",…}]
0: {id: 15, name: "戴帽子检测",…}
id: 15
name: "戴帽子检测"
param_data: [{param_name: "confidence", param_title: "佩戴置信度", param_val: "0-1.0", param_default_val: "0.5",…},…]
0: {param_name: "confidence", param_title: "佩戴置信度", param_val: "0-1.0", param_default_val: "0.5",…}
param_default_val: "0.5"
param_desc: ["默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时识别为违规佩戴，进行分析告警；", "开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；",…]
0: "默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时识别为违规佩戴，进行分析告警；"
1: "开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；"
2: "阈值越高，识别越精准，但漏识别概率增大。"
param_name: "confidence"
param_title: "佩戴置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.4",…}
param_default_val: "0.4"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 11
name: "c"
result_desc: "不佩戴安全帽行为"
skill_desc: ["面向工地、工厂车间、工业园区等场所，若检测到有工人未佩戴安全帽或佩戴不规范，则发出告警提醒，减少安全隐患"]
0: "面向工地、工厂车间、工业园区等场所，若检测到有工人未佩戴安全帽或佩戴不规范，则发出告警提醒，减少安全隐患"
skill_title: "人脸AI视觉"
skill_type: 1
type: 2
use_suspect: 0
*/

var skill_hat = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "安全帽佩戴合规检测",
    param_desc:
      "面向工地、工厂车间、工业园区等场所，<br>若检测到有工人未佩戴安全帽或佩戴不规范，则发出告警提醒，减少安全隐患",
    param_set_desc:
      "面向工地、工厂车间、工业园区等场所，<br>若检测到有工人未佩戴安全帽或佩戴不规范，则发出告警提醒，减少安全隐患",
    param_default_val: "安全帽佩戴合规检测",
    param_val: "安全帽佩戴合规检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_default_val: 11,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 11,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "不佩戴安全帽行为",
    param_desc: "",
    param_default_val: "不佩戴安全帽行为",
    param_val: "不佩戴安全帽行为",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_default_val: 15,
          param_min_val: 1,
          param_max_val: 32768,
          param_val: 15,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "戴帽子检测",
          param_desc: "",
          param_default_val: "戴帽子检测",
          param_val: "戴帽子检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "佩戴置信度",
          param_desc:
            "默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时识别为违规佩戴，进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；<br>阈值越高，识别越精准，但漏识别概率增大。",
          param_default_val: 0.5,
          param_val: 0.5,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.5，疑似默认值0.4。取值范围0-1，若检测值≥设定阈值时识别为违规佩戴，进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似违规佩戴，进行疑似分析告警；<br>阈值越高，识别越精准，但漏识别概率增大。",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.4,
          param_val: 0.4,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "wearhat",
          param_val: "wearhat",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: true,
          param_val: true,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98986",
          param_val: "601d24e22f94e4b548d98986",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 1, name: "人脸检测",…}, {id: 2, name: "人体检测",…}]
0: {id: 1, name: "人脸检测",…}
id: 1
name: "人脸检测"
param_data: [{param_name: "confidence", param_title: "人脸置信度", param_val: "0-1.0", param_default_val: "0.5",…},…]
0: {param_name: "confidence", param_title: "人脸置信度", param_val: "0-1.0", param_default_val: "0.5",…}
param_default_val: "0.5"
param_desc: ["默认值0.5，疑似默认值0.4。取值范围0-1", "确认值≥设定阈值时，才会被识别为有效人脸，进行分析告警；", "开启疑似，若检测值在疑似和确认阈值之间，疑似人脸，进行疑似分析告警；",…]
0: "默认值0.5，疑似默认值0.4。取值范围0-1"
1: "确认值≥设定阈值时，才会被识别为有效人脸，进行分析告警；"
2: "开启疑似，若检测值在疑似和确认阈值之间，疑似人脸，进行疑似分析告警；"
3: "推荐阈值范围：0.5~1，阈值越高，识别越精准，但漏识别概率增大"
param_name: "confidence"
param_title: "人脸置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.4",…}
param_default_val: "0.4"
param_desc: "是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {id: 2, name: "人体检测",…}
id: 2
name: "人体检测"
param_data: [{param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…},…]
0: {param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…}
param_default_val: "0.3"
param_desc: ["默认值0.3，疑似默认值0.2。取值范围0-1", "确认值≥设定阈值时，才会被识别为有效人体，进行分析告警；", "开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；",…]
0: "默认值0.3，疑似默认值0.2。取值范围0-1"
1: "确认值≥设定阈值时，才会被识别为有效人体，进行分析告警；"
2: "开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；"
3: "推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大"
param_name: "confidence"
param_title: "人体置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.2",…}
param_default_val: "0.2"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 4
name: "入侵检测"
result_desc: "违规入侵人员"
skill_desc: ["基于人体识别技术，判断是否有人员闯入，闯入告警"]
0: "基于人体识别技术，判断是否有人员闯入，闯入告警"
skill_title: "人脸AI视觉"
skill_type: 1
type: 2
use_suspect: 0
*/

var skill_come = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 3,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 3,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "入侵检测",
    param_desc: "基于人体识别技术，判断是否有人员闯入，闯入告警",
    param_set_desc: "基于人体识别技术，判断是否有人员闯入，闯入告警",
    param_default_val: "入侵检测",
    param_val: "入侵检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_default_val: 4,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 4,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "违规入侵人员",
    param_desc: "",
    param_default_val: "违规入侵人员",
    param_val: "违规入侵人员",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_default_val: 2,
          param_min_val: 1,
          param_max_val: 32768,
          param_val: 2,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "人体检测",
          param_desc: "",
          param_default_val: "人体检测",
          param_val: "人体检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "人型置信度",
          param_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
          param_default_val: 0.3,
          param_val: 0.3,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。",
          param_default_val: 0.2,
          param_val: 0.2,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。",
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "person",
          param_val: "person",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98985",
          param_val: "601d24e22f94e4b548d98985",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 2, name: "人体检测",…}]
0: {id: 2, name: "人体检测",…}
id: 2
name: "人体检测"
param_data: [{param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…},…]
0: {param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…}
param_default_val: "0.3"
param_desc: ["默认值0.3，疑似默认值0.2。取值范围0-1", "确认值≥设定阈值时，才会被识别为有效人体，进行攀高分析，否则将丢弃图片。",…]
0: "默认值0.3，疑似默认值0.2。取值范围0-1"
1: "确认值≥设定阈值时，才会被识别为有效人体，进行攀高分析，否则将丢弃图片。"
2: "开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似攀高分析告警；"
3: "推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大"
param_name: "confidence"
param_title: "人体置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.2",…}
param_default_val: "0.2"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 7
name: "攀高检测"
result_desc: "攀高人员"
skill_desc: ["基于电子围栏，实时监控楼宇、工地、社区等场所的高风险区域，发现攀高行为则及时告警提醒，避免异常攀高导致安全事故"]
0: "基于电子围栏，实时监控楼宇、工地、社区等场所的高风险区域，发现攀高行为则及时告警提醒，避免异常攀高导致安全事故"
skill_title: "人脸AI视觉"
skill_type: 1
type: 2
use_suspect: 0
*/

var skill_high = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 4,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 4,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "攀高检测",
    param_desc:
      "基于电子围栏，实时监控楼宇、工地、社区等场所的高风险区域，<br>发现攀高行为则及时告警提醒，避免异常攀高导致安全事故",
    param_set_desc:
      "基于电子围栏，实时监控楼宇、工地、社区等场所的高风险区域，<br>发现攀高行为则及时告警提醒，避免异常攀高导致安全事故",
    param_default_val: "攀高检测",
    param_val: "攀高检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 7,
    param_val: 7,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "攀高人员",
    param_desc: "",
    param_default_val: "攀高人员",
    param_val: "攀高人员",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 2,
          param_val: 2,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "人体检测",
          param_desc: "",
          param_default_val: "人体检测",
          param_val: "人体检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "人体置信度",
          param_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，进行攀高分析，否则将丢弃图片。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似攀高分析告警；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
          param_default_val: 0.3,
          param_val: 0.3,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，进行攀高分析，否则将丢弃图片。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似攀高分析告警；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.2,
          param_val: 0.2,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "person",
          param_val: "person",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98985",
          param_val: "601d24e22f94e4b548d98985",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 2, name: "人体检测",…}]
0: {id: 2, name: "人体检测",…}
id: 2
name: "人体检测"
param_data: [{param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…},…]
0: {param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…}
param_default_val: "0.3"
param_desc: ["默认值0.3，疑似默认值0.2。取值范围0-1", "确认值≥设定阈值时，才会被识别为有效人体，进行人流密度分析，否则将丢弃图片。",…]
0: "默认值0.3，疑似默认值0.2。取值范围0-1"
1: "确认值≥设定阈值时，才会被识别为有效人体，进行人流密度分析，否则将丢弃图片。"
2: "开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；"
3: "推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大"
param_name: "confidence"
param_title: "人体置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.2",…}
param_default_val: "0.2"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
2: {param_name: "quantity", param_title: "设置人数上限", param_val: "1-20", param_default_val: 10,…}
param_default_val: 10
param_desc: ["默认值：10，范围1-20 注释：当检测到的人数超过您设置的数量，则发出告警"]
0: "默认值：10，范围1-20 注释：当检测到的人数超过您设置的数量，则发出告警"
param_name: "quantity"
param_title: "设置人数上限"
param_type: 2
param_val: "1-20"
show_type: 4
id: 5
name: "人群聚集"
result_desc: "人群聚集"
skill_desc: ["实时监控人流量，当人数超过设定上限时告警提醒，及时发现人群异常聚集等情况，合理疏散、导流，规避安全事故"]
0: "实时监控人流量，当人数超过设定上限时告警提醒，及时发现人群异常聚集等情况，合理疏散、导流，规避安全事故"
skill_title: "人脸AI视觉"
skill_type: 1
type: 2
use_suspect: 0
*/

var skill_more = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 5,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 5,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "人群聚集",
    param_desc:
      "实时监控人流量，当人数超过设定上限时告警提醒，<br>及时发现人群异常聚集等情况，合理疏散、导流，规避安全事故",
    param_set_desc:
      "实时监控人流量，当人数超过设定上限时告警提醒，<br>及时发现人群异常聚集等情况，合理疏散、导流，规避安全事故",
    param_default_val: "人群聚集",
    param_val: "人群聚集",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 5,
    param_val: 5,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "人群聚集",
    param_desc: "",
    param_default_val: "人群聚集",
    param_val: "人群聚集",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 2,
          param_val: 2,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "人体检测",
          param_desc: "",
          param_default_val: "人体检测",
          param_val: "人体检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "人体置信度",
          param_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，进行人流密度分析，否则将丢弃图片。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
          param_default_val: 0.3,
          param_val: 0.3,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，进行人流密度分析，否则将丢弃图片。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人体，进行疑似分析告警；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.2,
          param_val: 0.2,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "person",
          param_val: "person",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98985",
          param_val: "601d24e22f94e4b548d98985",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "quantity",
          param_data_type: 1,
          param_show: true,
          param_show_type: 4,
          param_title: "设置人数上限",
          param_option: "1-20",
          param_min_val: 1,
          param_max_val: 10000,
          param_desc:
            "默认值：10，范围1-10000 注释：当检测到的人数超过您设置的数量，则发出告警",
          param_default_val: 10,
          param_val: 10,
          param_set_desc:
            "默认值：10，范围1-10000 注释：当检测到的人数超过您设置的数量，则发出告警",
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 2, name: "人体检测",…}]
0: {id: 2, name: "人体检测",…}
id: 2
name: "人体检测"
param_data: [{param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…},…]
0: {param_name: "confidence", param_title: "人体置信度", param_val: "0-1.0", param_default_val: "0.3",…}
param_default_val: "0.3"
param_desc: ["默认值0.3，疑似默认值0.2。取值范围0-1", "确认值≥设定阈值时，才会被识别为有效人体，进一步结合告警周期，进行徘徊行为分析，否则将丢弃图片。",…]
0: "默认值0.3，疑似默认值0.2。取值范围0-1"
1: "确认值≥设定阈值时，才会被识别为有效人体，进一步结合告警周期，进行徘徊行为分析，否则将丢弃图片。"
2: "开启疑似，若检测值在疑似和确认阈值之间，进一步结合告警周期，进行疑似徘徊行为分析；"
3: "推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大"
param_name: "confidence"
param_title: "人体置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.2",…}
param_default_val: "0.2"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 6
name: "徘徊检测"
result_desc: "徘徊人员"
skill_data: [{param_name: "alarm_period", param_title: "告警周期", param_val: "1-60", param_default_val: 1,…}]
0: {param_name: "alarm_period", param_title: "告警周期", param_val: "1-60", param_default_val: 1,…}
param_default_val: 1
param_desc: ["在告警周期内的徘徊不报警，超过告警周期的徘徊行为报警"]
0: "在告警周期内的徘徊不报警，超过告警周期的徘徊行为报警"
param_name: "alarm_period"
param_title: "告警周期"
param_type: 2
param_val: "1-60"
show_type: 4
skill_desc: ["检测人员在警戒区域中停留或行走时间超过设定时间报警，基于人体识别、电子围栏，可结合人脸库做白名单过滤。"]
0: "检测人员在警戒区域中停留或行走时间超过设定时间报警，基于人体识别、电子围栏，可结合人脸库做白名单过滤。"
skill_title: "人脸AI视觉"
skill_type: 1
type: 2
use_suspect: 0
*/

var skill_move = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 6,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 6,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "徘徊检测",
    param_desc: "检测人员在警戒区域中停留或行走时间超过设定时间报警",
    param_set_desc: "检测人员在警戒区域中停留或行走时间超过设定时间报警",
    param_default_val: "徘徊检测",
    param_val: "徘徊检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 6,
    param_val: 6,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "alarm_period",
    param_data_type: 1,
    param_show: true,
    param_show_type: 4,
    param_title: "告警周期",
    param_option: "1-60",
    param_min_val: 1,
    param_max_val: 60,
    param_desc: "在告警周期内的徘徊不报警，超过告警周期的徘徊行为报警",
    param_default_val: 1,
    param_val: 1,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "徘徊人员",
    param_desc: "",
    param_default_val: "徘徊人员",
    param_val: "徘徊人员",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 2,
          param_val: 2,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "人体检测",
          param_desc: "",
          param_default_val: "人体检测",
          param_val: "人体检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "人体置信度",
          param_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，<br>进一步结合告警周期，进行徘徊行为分析，否则将丢弃图片。<br>开启疑似，若检测值在疑似和确认阈值之间，<br>进一步结合告警周期，进行疑似徘徊行为分析；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
          param_default_val: 0.3,
          param_val: 0.3,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.3，疑似默认值0.2。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人体，<br>进一步结合告警周期，进行徘徊行为分析，否则将丢弃图片。<br>开启疑似，若检测值在疑似和确认阈值之间，<br>进一步结合告警周期，进行疑似徘徊行为分析；<br>推荐阈值范围：0.3~1，阈值越高，识别越精准，但漏识别概率增大",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.2,
          param_val: 0.2,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "person",
          param_val: "person",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98985",
          param_val: "601d24e22f94e4b548d98985",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 14, name: "玩手机检测",…}]
0: {id: 14, name: "玩手机检测",…}
id: 14
name: "玩手机检测"
param_data: [{param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.8",…},…]
0: {param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.8",…}
param_default_val: "0.8"
param_desc: ["默认值0.8，疑似默认值0.6。取值范围0-1", "确认值≥设定阈值时，才会被识别为玩手机行为；", "开启疑似，若检测值在疑似和确认阈值之间，疑似玩手机；",…]
0: "默认值0.8，疑似默认值0.6。取值范围0-1"
1: "确认值≥设定阈值时，才会被识别为玩手机行为；"
2: "开启疑似，若检测值在疑似和确认阈值之间，疑似玩手机；"
3: "推荐阈值范围0.8~1，阈值越高，识别越精准，但漏识别概率增大"
param_name: "confidence"
param_title: "置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.6",…}
param_default_val: "0.6"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 9
name: "玩手机识别"
result_desc: "玩手机行为"
skill_desc: ["对监控区域的玩手机现象进行识别并发出告警，方便管理人员及时处理，提高生产效率"]
0: "对监控区域的玩手机现象进行识别并发出告警，方便管理人员及时处理，提高生产效率"
skill_title: "物品检测"
skill_type: 2
type: 2
use_suspect: 0
*/

var skill_phone = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 7,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 7,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "玩手机识别",
    param_desc:
      "对监控区域的玩手机现象进行识别并发出告警，方便管理人员及时处理，提高生产效率",
    param_set_desc:
      "对监控区域的玩手机现象进行识别并发出告警，<br>方便管理人员及时处理，提高生产效率",
    param_default_val: "玩手机识别",
    param_val: "玩手机识别",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 9,
    param_val: 9,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "玩手机行为",
    param_desc: "",
    param_default_val: "玩手机行为",
    param_val: "玩手机行为",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 14,
          param_val: 14,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "玩手机检测",
          param_desc: "",
          param_default_val: "玩手机检测",
          param_val: "玩手机检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "置信度",
          param_desc:
            "默认值0.8，疑似默认值0.6。取值范围0-1<br>确认值≥设定阈值时，才会被识别为玩手机行为；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似玩手机；<br>推荐阈值范围0.8~1，阈值越高，识别越精准，但漏识别概率增大",
          param_default_val: 0.8,
          param_val: 0.8,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.8，疑似默认值0.6。取值范围0-1<br>确认值≥设定阈值时，才会被识别为玩手机行为；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似玩手机；<br>推荐阈值范围0.8~1，阈值越高，识别越精准，但漏识别概率增大",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.6,
          param_val: 0.6,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "hand_phone",
          param_val: "hand_phone",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98984",
          param_val: "601d24e22f94e4b548d98984",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 13, name: "吸烟检测",…}]
0: {id: 13, name: "吸烟检测",…}
id: 13
name: "吸烟检测"
param_data: [{param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.5",…},…]
0: {param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.5",…}
param_default_val: "0.5"
param_desc: ["确认值≥设定阈值时，才会被识别为吸烟行为，否则将过滤掉此动作。", "开启疑似，若检测值在疑似和确认阈值之间，疑似吸烟行为，进行疑似吸烟分析；"]
0: "确认值≥设定阈值时，才会被识别为吸烟行为，否则将过滤掉此动作。"
1: "开启疑似，若检测值在疑似和确认阈值之间，疑似吸烟行为，进行疑似吸烟分析；"
param_name: "confidence"
param_title: "置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.4",…}
param_default_val: "0.4"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 10
name: "吸烟检测"
result_desc: "吸烟行为"
skill_desc: ["识别出吸烟动作时告警，用于禁烟的厂房或公共场所，协助相关部门进行烟控，提高安全指数与管控效率"]
0: "识别出吸烟动作时告警，用于禁烟的厂房或公共场所，协助相关部门进行烟控，提高安全指数与管控效率"
skill_title: "物品检测"
skill_type: 2
type: 2
use_suspect: 0
*/

var skill_smoke = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 8,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 8,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "吸烟检测",
    param_desc:
      "识别出吸烟动作时告警，用于禁烟的厂房或公共场所，<br>协助相关部门进行烟控，提高安全指数与管控效率",
    param_set_desc:
      "识别出吸烟动作时告警，用于禁烟的厂房或公共场所，<br>协助相关部门进行烟控，提高安全指数与管控效率",
    param_default_val: "吸烟检测",
    param_val: "吸烟检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 10,
    param_val: 10,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "吸烟行为",
    param_desc: "",
    param_default_val: "吸烟行为",
    param_val: "吸烟行为",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 13,
          param_val: 13,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "吸烟检测",
          param_desc: "",
          param_default_val: "吸烟检测",
          param_val: "吸烟检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "置信度",
          param_desc:
            "确认值≥设定阈值时，才会被识别为吸烟行为，否则将过滤掉此动作。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似吸烟行为，进行疑似吸烟分析；",
          param_default_val: 0.5,
          param_val: 0.5,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "确认值≥设定阈值时，才会被识别为吸烟行为，否则将过滤掉此动作。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似吸烟行为，进行疑似吸烟分析；",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.4,
          param_val: 0.4,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "smoke",
          param_val: "smoke",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98983",
          param_val: "601d24e22f94e4b548d98983",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 16, name: "火灾检测",…}]
0: {id: 16, name: "火灾检测",…}
id: 16
name: "火灾检测"
param_data: [{param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.5",…},…]
0: {param_name: "confidence", param_title: "置信度", param_val: "0-1.0", param_default_val: "0.5",…}
param_default_val: "0.5"
param_desc: ["确认值≥设定阈值时，才会被识别为烟火，否则将过滤掉此图片。", "开启疑似，若检测值在疑似和确认阈值之间，疑似烟火，进行疑似烟火分析；"]
0: "确认值≥设定阈值时，才会被识别为烟火，否则将过滤掉此图片。"
1: "开启疑似，若检测值在疑似和确认阈值之间，疑似烟火，进行疑似烟火分析；"
param_name: "confidence"
param_title: "置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.4",…}
param_default_val: "0.4"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 8
name: "烟火检测"
result_desc: "火灾"
skill_desc: ["在工厂车间、仓库、楼道、园区、校区等场景下，监控是否有烟火，烟火出现及时告警提醒，减少人身财产安全损伤。"]
0: "在工厂车间、仓库、楼道、园区、校区等场景下，监控是否有烟火，烟火出现及时告警提醒，减少人身财产安全损伤。"
skill_title: "物品检测"
skill_type: 2
type: 2
use_suspect: 0
*/

var skill_fire = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 9,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 9,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "烟火检测",
    param_desc:
      "在工厂车间、仓库、楼道、园区、校区等场景下，监控是否有烟火，<br>烟火出现及时告警提醒，减少人身财产安全损伤。",
    param_set_desc:
      "在工厂车间、仓库、楼道、园区、校区等场景下，<br>监控是否有烟火，烟火出现及时告警提醒，减少人身财产安全损伤。",
    param_default_val: "烟火检测",
    param_val: "烟火检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 8,
    param_val: 8,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "烟火",
    param_desc: "",
    param_default_val: "烟火",
    param_val: "烟火",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 16,
          param_val: 16,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "烟火检测",
          param_desc: "",
          param_default_val: "烟火检测",
          param_val: "烟火检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "置信度",
          param_desc:
            "确认值≥设定阈值时，才会被识别为烟火，否则将过滤掉此图片。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似烟火，进行疑似烟火分析；",
          param_default_val: 0.5,
          param_val: 0.5,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "确认值≥设定阈值时，才会被识别为烟火，否则将过滤掉此图片。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似烟火，进行疑似烟火分析；",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.4,
          param_val: 0.4,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "dayfire",
          param_val: "dayfire",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98987",
          param_val: "601d24e22f94e4b548d98987",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];
/*
ai_data: [{id: 9, name: "车辆检测",…}]
0: {id: 9, name: "车辆检测",…}
id: 9
name: "车辆检测"
param_data: [{param_name: "confidence", param_title: "车辆置信度", param_val: "0-1.0", param_default_val: "0.5",…},…]
0: {param_name: "confidence", param_title: "车辆置信度", param_val: "0-1.0", param_default_val: "0.5",…}
param_default_val: "0.5"
param_desc: ["确认值≥设定阈值时，才会被识别为车辆，进一步结合告警周期，进行车辆违停行为分析。", "开启疑似，若检测值在疑似和确认阈值之间，疑似车辆，进一步结合告警周期，进行疑似车辆违停行为分析；"]
0: "确认值≥设定阈值时，才会被识别为车辆，进一步结合告警周期，进行车辆违停行为分析。"
1: "开启疑似，若检测值在疑似和确认阈值之间，疑似车辆，进一步结合告警周期，进行疑似车辆违停行为分析；"
param_name: "confidence"
param_title: "车辆置信度"
param_type: 1
param_val: "0-1.0"
show_type: 1
1: {param_name: "suspect_confidence", param_title: "疑似值", param_val: "0-1.0", param_default_val: "0.4",…}
param_default_val: "0.4"
param_desc: ["是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"]
0: "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。"
param_name: "suspect_confidence"
param_title: "疑似值"
param_type: 1
param_val: "0-1.0"
show_type: 1
id: 12
name: "车辆违停检测"
result_desc: "违停车辆"
skill_data: [{param_name: "alarm_period", param_title: "告警周期", param_val: "1-60", param_default_val: 1,…}]
0: {param_name: "alarm_period", param_title: "告警周期", param_val: "1-60", param_default_val: 1,…}
param_default_val: 1
param_desc: ["在告警周期内的违停不报警，超过告警周期的违停行为报警"]
0: "在告警周期内的违停不报警，超过告警周期的违停行为报警"
param_name: "alarm_period"
param_title: "告警周期"
param_type: 2
param_val: "1-60"
show_type: 4
skill_desc: ["基于电子围栏、车牌及车辆检测算法，发现车辆违规停放时告警提醒，可自定义违停时间周期"]
0: "基于电子围栏、车牌及车辆检测算法，发现车辆违规停放时告警提醒，可自定义违停时间周期"
skill_title: "车辆检测"
skill_type: 3
type: 2
use_suspect: 0

*/
var skill_stop = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 10,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 10,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "车辆违停检测",
    param_desc:
      "基于电子围栏、车牌及车辆检测算法，<br>发现车辆违规停放时告警提醒，可自定义违停时间周期",
    param_set_desc:
      "基于电子围栏、车牌及车辆检测算法，<br>发现车辆违规停放时告警提醒，可自定义违停时间周期",
    param_default_val: "车辆违停检测",
    param_val: "车辆违停检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_min_val: 1,
    param_max_val: 32768,
    param_default_val: 12,
    param_val: 12,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "alarm_period",
    param_data_type: 1,
    param_show: true,
    param_show_type: 4,
    param_title: "告警周期",
    param_option: "1-60",
    param_min_val: 1,
    param_max_val: 60,
    param_desc: "在告警周期内的违停不报警，超过告警周期的违停行为报警",
    param_default_val: 1,
    param_val: 1,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "违停车辆",
    param_desc: "",
    param_default_val: "违停车辆",
    param_val: "违停车辆",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_min_val: 1,
          param_max_val: 32768,
          param_default_val: 9,
          param_val: 9,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "车辆检测",
          param_desc: "",
          param_default_val: "车辆检测",
          param_val: "车辆检测",
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 0,
          param_val: 0,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "车辆置信度",
          param_desc:
            "确认值≥设定阈值时，才会被识别为车辆，<br>进一步结合告警周期，进行车辆违停行为分析。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似车辆，<br>进一步结合告警周期，进行疑似车辆违停行为分析",
          param_default_val: 0.5,
          param_val: 0.5,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "确认值≥设定阈值时，才会被识别为车辆，<br>进一步结合告警周期，进行车辆违停行为分析。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似车辆，<br>进一步结合告警周期，进行疑似车辆违停行为分析",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.4,
          param_val: 0.4,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "car",
          param_val: "car",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d9898d",
          param_val: "601d24e22f94e4b548d9898d",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 1,
          param_val: 1,
          param_min_val: 1,
          param_max_val: 32768,
        },
      ],
    ],
  },
];

var skill_cargroup = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 11,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 11,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "车辆跨越检测",
    param_desc:
      "基于电子围栏、车牌及车辆检测算法，<br>发现车辆越界告警提醒，可结合车辆白名单使用",
    param_set_desc:
      "基于电子围栏、车牌及车辆检测算法，<br>发现车辆越界告警提醒，可结合车辆白名单使用",
    param_default_val: "车辆跨越检测",
    param_val: "车辆跨越检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_default_val: 14,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 14,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "跨越车辆",
    param_desc: "",
    param_default_val: "车牌识别",
    param_val: "车牌识别",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_default_val: 5,
          param_min_val: 1,
          param_max_val: 32768,
          param_val: 5,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "车牌识别",
          param_desc: "",
          param_default_val: "车牌识别",
          param_val: "车牌识别",
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "车牌置信度",
          param_desc:
            "确认值≥设定阈值时，才会被识别为车牌，<br>进一步结合车牌库，进行车辆跨越行为分析，白名单车牌不告警。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似车牌，<br>进一步判断是否是车牌库白名单车牌，白名单车牌不告警。",
          param_default_val: 0.3,
          param_val: 0.3,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "确认值≥设定阈值时，才会被识别为车牌，<br>进一步结合车牌库，进行车辆跨越行为分析，白名单车牌不告警。<br>开启疑似，若检测值在疑似和确认阈值之间，疑似车牌，<br>进一步判断是否是车牌库白名单车牌，白名单车牌不告警。",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
          param_default_val: 0.2,
          param_val: 0.2,
          param_min_val: 0,
          param_max_val: 1,
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "http://backend.lite.prophet.360.cn/piazza/predict",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "License plate",
          param_val: "License plate",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "601d24e22f94e4b548d98989",
          param_val: "601d24e22f94e4b548d98989",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 2,
          param_val: 2,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 2,
          param_val: 2,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_data_type: 11,
          param_default_val: 2,
          param_desc: "1-人脸，2-车牌",
          param_max_val: 32768,
          param_min_val: 1,
          param_name: "ai_recognize_group_type",
          param_option: { 1: "人脸库", 2: "车牌库" },
          param_show: false,
          param_show_type: 3,
          param_temp: { param_option_min: 1, param_option_max: 2 },
          param_title: "ai识别库类型",
          param_val: 2,
          param_hit: false,
        },
        {
          param_data_type: 4,
          param_default_val: [],
          param_set_desc:
            "此技能支持搭配车牌库白名单，若检测到配置的白名单车牌视作允许跨越车辆不报警，如关联车牌库请先<a>创建车牌组<a>",
          param_name: "ai_non_hit_list",
          param_show: true,
          param_show_type: 6,
          param_title: "车牌白名单",
          param_val: [],
          param_desc:
            "此技能支持搭配车牌库白名单，若检测到配置的白名单车牌视作允许跨越车辆不报警，如关联车牌库请先<a>创建车牌组<a>",
        },
        {
          param_name: "ai_recognize_score",
          param_data_type: 2,
          param_show: false,
          param_title: "ai识别分数0~1.0",
          param_desc: "从向量数据库查询图片的相知度指标，越大越相似",
          param_default_val: 0.95,
          param_val: 0.95,
        },
      ],
    ],
  },
];

/*****************************************************************************************************************/

var skill_facegroup = [
  {
    param_name: "skill_show",
    param_data_type: 0,
    param_show: false,
    param_show_type: 1,
    param_title: "是否启用",
    param_desc: "",
    param_default_val: true,
    param_val: true,
  },
  {
    param_name: "order_id",
    param_data_type: 1,
    param_show: false,
    param_title: "排序序号",
    param_desc: "",
    param_default_val: 12,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 12,
  },
  {
    param_name: "type",
    param_data_type: 1,
    param_show: false,
    param_show_type: 3,
    param_option: { 1: "抽帧", 2: "通用AI技能", 3: "云存" },
    param_title: "技能类型",
    param_desc: "",
    param_default_val: 2,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 2,
  },
  {
    param_name: "skill_name",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "陌生人检测",
    param_desc:
      "在园区、厂区、学校等场所对陌生人进行布控，可搭配人脸白名单用使用，<br>熟人不告警。若检测不到白名单成员的人脸亦视作陌生人，用于加强环境安全监督",
    param_set_desc:
      "在园区、厂区、学校等场所对陌生人进行布控，可搭配人脸白名单用使用，<br>熟人不告警。若检测不到白名单成员的人脸亦视作陌生人，用于加强环境安全监督",
    param_default_val: "陌生人检测",
    param_val: "陌生人检测",
  },
  {
    param_name: "on",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "开关",
    param_desc: "",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "skill_id",
    param_data_type: 1,
    param_show: false,
    param_title: "技能Id",
    param_desc: "",
    param_default_val: 15,
    param_min_val: 1,
    param_max_val: 32768,
    param_val: 15,
  },
  {
    param_name: "use_suspect",
    param_data_type: 0,
    param_show: true,
    param_show_type: 1,
    param_title: "是否开启疑似",
    param_desc:
      "是否开启疑似值，启用后置信度大于疑似值小于确认值，用于疑似分析及预警。",
    param_default_val: false,
    param_val: false,
  },
  {
    param_name: "record_file_duration",
    param_data_type: 1,
    param_show: false,
    param_title: "上报文件时长",
    param_desc: "毫秒为单位",
    param_default_val: 15000,
    param_val: 15000,
    param_min_val: 10000,
    param_max_val: 1000000,
  },
  {
    param_name: "small_jpg_resolution",
    param_data_type: 1,
    param_show: false,
    param_title: "小封面图分辨率",
    param_desc: "1-352x288",
    param_default_val: 1,
    param_val: 1,
    param_min_val: 1,
    param_max_val: 32768,
  },
  {
    param_name: "region_cover_rate",
    param_data_type: 2,
    param_show: false,
    param_title: "检测区域覆盖率",
    param_desc: "",
    param_default_val: 0.5,
    param_val: 0.5,
    param_min_val: 0,
    param_max_val: 1,
  },
  {
    param_name: "check_region",
    param_data_type: 8,
    param_show: false,
    param_title: "检测区域",
    param_desc: "",
    param_default_val: [],
    param_val: [],
  },
  {
    param_name: "result_desc",
    param_data_type: 3,
    param_show: false,
    param_show_type: 9,
    param_title: "陌生人员",
    param_desc: "",
    param_default_val: "陌生人员",
    param_val: "陌生人员",
  },
  {
    param_name: "ai_params",
    param_data_type: 10,
    param_show: false,
    param_default_val: [],
    param_val: [
      [
        {
          param_name: "ai_id",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型id",
          param_desc: "",
          param_default_val: 22,
          param_min_val: 1,
          param_max_val: 32768,
          param_val: 22,
        },
        {
          param_name: "ai_name",
          param_data_type: 3,
          param_show: false,
          param_title: "人脸识别",
          param_desc: "",
          param_default_val: "人脸识别",
          param_val: "人脸识别",
        },
        {
          param_name: "ai_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "人脸置信度",
          param_desc:
            "默认值0.5，疑似默认值0.4。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人脸，可结合人脸白名单进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人脸，可结合人脸白名单进行疑似分析告警分析；<br>推荐阈值范围：0.5~1，阈值越高，识别越精准，但漏识别概率增大",
          param_default_val: 0.5,
          param_val: 0.5,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "默认值0.5，疑似默认值0.4。取值范围0-1<br>确认值≥设定阈值时，才会被识别为有效人脸，可结合人脸白名单进行分析告警；<br>开启疑似，若检测值在疑似和确认阈值之间，疑似人脸，可结合人脸白名单进行疑似分析告警分析；<br>推荐阈值范围：0.5~1，阈值越高，识别越精准，但漏识别概率增大",
        },
        {
          param_name: "ai_suspect_confidence",
          param_data_type: 2,
          param_show: true,
          param_show_type: 2,
          param_title: "疑似值",
          param_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。",
          param_default_val: 0.4,
          param_val: 0.4,
          param_min_val: 0,
          param_max_val: 1,
          param_set_desc:
            "是否开启疑似值，启用后置信度大于疑似值小于确认值，疑似报警。",
        },
        {
          param_name: "ai_access_url",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用url",
          param_desc: "",
          param_default_val:
            "http://backend.lite.prophet.360.cn/piazza/predict",
          param_val: "http://backend.lite.prophet.360.cn/piazza/predict",
        },
        {
          param_name: "ai_check_label",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型check label",
          param_desc: "",
          param_default_val: "person",
          param_val: "person",
        },
        {
          param_name: "ai_check_label_negative",
          param_data_type: 0,
          param_show: false,
          param_title: "ai模型check label是否取反",
          param_desc: "",
          param_default_val: false,
          param_val: false,
        },
        {
          param_name: "ai_access_id",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用id",
          param_desc: "",
          param_default_val: "6065a85df13f53d7744e12df",
          param_val: "6065a85df13f53d7744e12df",
        },
        {
          param_name: "ai_access_context_type",
          param_data_type: 3,
          param_show: false,
          param_title: "ai模型调用时的context-type类型",
          param_desc: "",
          param_default_val: "multipart/form-data",
          param_val: "multipart/form-data",
        },
        {
          param_name: "ai_model_type",
          param_data_type: 1,
          param_show: false,
          param_title: "ai模型类型",
          param_desc: "1-ai检测类型，2-ai识别类型",
          param_default_val: 2,
          param_val: 2,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_name: "ai_type",
          param_data_type: 1,
          param_show: false,
          param_show_type: 3,
          param_option: { 0: "不关联库", 1: "人脸库", 2: "车牌库" },
          param_title: "关联库类型",
          param_desc: "",
          param_default_val: 2,
          param_val: 2,
          param_min_val: 1,
          param_max_val: 32768,
        },
        {
          param_data_type: 11,
          param_default_val: 1,
          param_desc: "1-人脸，2-车牌",
          param_max_val: 32768,
          param_min_val: 1,
          param_name: "ai_recognize_group_type",
          param_option: { 1: "人脸库", 2: "车牌库" },
          param_show: false,
          param_show_type: 3,
          param_temp: { param_option_min: 1, param_option_max: 2 },
          param_title: "ai识别库类型",
          param_val: 1,
          param_hit: false,
        },
        {
          param_data_type: 4,
          param_default_val: [],
          param_set_desc:
            "此技能支持搭配人脸库使用，若检测到配置的人脸白名单成员视作熟人不报警，如关联白名单人脸库请先<a>创建人脸组<a>",
          param_name: "ai_non_hit_list",
          param_show: true,
          param_show_type: 6,
          param_title: "不告警成员",
          param_val: [],
          param_desc:
            "此技能支持搭配人脸库使用，若检测到配置的人脸白名单成员视作熟人不报警，如关联白名单人脸库请先<a>创建人脸组<a>",
        },
        {
          param_name: "ai_recognize_score",
          param_data_type: 2,
          param_show: false,
          param_title: "ai识别分数0~1.0",
          param_desc: "从向量数据库查询图片的相知度指标，越大越相似",
          param_default_val: 0.95,
          param_val: 0.95,
        },
      ],
    ],
  },
];

/*****************************************************************************************************************/
/*****************************************************************************************************************/
/*****************************************************************************************************************/
/*****************************************************************************************************************/
/*****************************************************************************************************************/

var skillList = [
  skill_mask,
  skill_hat,
  skill_come,
  skill_high,
  skill_more,
  skill_move,
  skill_phone,
  skill_smoke,
  skill_fire,
  skill_stop,
  skill_cargroup,
  skill_facegroup,
];

export default skillList;
</script>


// WEBPACK FOOTER //
// src/components/utils/skill_config.vue